"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconSocialYoutube = function SvgIconSocialYoutube(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "social youtube icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Social Youtube Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M43.99 25.158c-.06 4.467-.473 8.956-2.316 10.616-.711.64-1.388 1.041-4.095 1.29-3.383.314-7.969.356-11.433.363-1.43.002-2.86.002-4.291 0-3.467-.007-8.05-.049-11.436-.363-2.704-.249-3.381-.65-4.094-1.29-1.875-1.688-2.27-6.305-2.319-10.847-.008-.846-.008-1.695.003-2.54.054-4.506.457-9.06 2.316-10.732.713-.641 1.39-1.042 4.094-1.29 3.386-.314 7.97-.357 11.436-.363 1.43-.003 2.86-.003 4.291 0 3.464.006 8.05.049 11.433.362 2.707.25 3.384.65 4.095 1.29 1.843 1.66 2.255 6.15 2.316 10.617.013.96.013 1.926 0 2.887zm-23.905-7.513v11.773l10.093-5.704-10.093-6.069z"
  }));
};

var _default = SvgIconSocialYoutube;
exports.default = _default;